import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiResponse } from '../_model/ApiResponse';
import { LookupRequest } from '../_model/request/LookupRequest';
import { Lookup } from '../_model/Lookup';
import { EventService } from './event.service';

@Injectable({
  providedIn: 'root'
})
export class LookupService extends BaseService {

  constructor(http: HttpClient,
    private eventService: EventService) {
    super(http);
  }

  saveLookup(lookupRequest: LookupRequest): Observable<ApiResponse> {
    return this.post<ApiResponse>('/api/v1/lookups', lookupRequest);
  }

  updateLookup(lookupRequest: LookupRequest): Observable<ApiResponse> {
    return this.put<ApiResponse>('/api/v1/lookups', lookupRequest);
  }

  listLookups(): Observable<ApiResponse> {
    return this.get<ApiResponse>('/api/v1/lookups');
  }

  listByLookupCode(lookupCode: string): Observable<ApiResponse> {
    return this.get<ApiResponse>('/api/v1/lookups/' + lookupCode);
  }

  deleteLookup(lookup: Lookup): Observable<ApiResponse> {
    return this.delete<ApiResponse>('/api/v1/lookups/' + lookup.id);
  }

  // local calls by using event service
  localListByLookupCode(lookupCode: string): Lookup[] {
    const lookupList = localStorage.getItem('lookupList');
    if (!lookupList) {
      return [];
    }
    return JSON.parse(lookupList).filter(value => value.lookupCode === lookupCode);
  }

  localListById(id: number): any {
    const lookupList = localStorage.getItem('lookupList');
    if (!lookupList) {
      return null;
    }
    return JSON.parse(lookupList).filter(value => value.id === id)[0];
  }

  localListLookups(): Lookup[] {
    const lookupList = localStorage.getItem('lookupList');
    if (!lookupList) {
      return [];
    }
    return JSON.parse(lookupList);
  }

  localRejectReasonLookupList(): Lookup[] {
    return JSON.parse(localStorage.getItem('lookupList')).filter(value => value.lookupCode === 'REJECT_REASON');
  }

  localOvertimeRejectReasonLookupList(): Lookup[] {
    return JSON.parse(localStorage.getItem('lookupList')).filter(value => value.lookupCode === 'OVERTIME_REJECT_REASON');
  }


}
